import { Chip } from '@mui/material';
import React from 'react';

interface MoreValuesChipProps {
    onClick: () => void;
    nbExtraValues: number;
}

const MoreValuesChip = ({ onClick, nbExtraValues }: MoreValuesChipProps) => (
    <Chip
        sx={{ width: 'fit-content' }}
        color="primary"
        variant="outlined"
        label={`+ ${nbExtraValues}`}
        onClick={onClick}
    />
);

export default MoreValuesChip;
